const ProfileInfoDisplay = ({ admin }) => {
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max-w-md mx-auto space-y-4">
      <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">Your Profile</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4 text-sm">
        <div className="font-semibold text-gray-700 dark:text-gray-300">Username:</div>
        <div className="text-gray-900 dark:text-gray-100">
          {admin.username || <span className="text-gray-400 dark:text-gray-500">(Not set)</span>}
        </div>

        <div className="font-semibold text-gray-700 dark:text-gray-300">Email:</div>
        <div className="text-gray-900 dark:text-gray-100">{admin.email}</div>

        <div className="font-semibold text-gray-700 dark:text-gray-300">Role:</div>
        <div className="capitalize text-gray-900 dark:text-gray-100">{admin.role}</div>
      </div>
    </div>
  );
};

export default ProfileInfoDisplay;
